export const enum ShiftCalendarMode {
    SHIFTS = "SHIFTS",
    DAILY_WEEKLY = "DAILY_WEEKLY",
    ONLY_ONCE = "ONLY_ONCE"
}


// WEBPACK FOOTER //
// ./src/Components/ShiftCalendar/ShiftCalendarMode.ts